import Axios, { AxiosInstance } from "axios";
import router from "@/router";
import Vue from "vue";
import authHeader from "@/common/qAuthHeader";

class api {
  public http: any;
  public loader: any;

  getHttp(): AxiosInstance {
    return this.http;
  }
  setup(): void {
    // set basic url or token
    const config = {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      baseURL: process.env.VUE_APP_API_URL,
    };

    this.http = Axios.create(config);
    this.http.interceptors.request.use(
      (config: any) => {
        const token = authHeader();
        this.loader && this.loader.hide();
        if (!(config.data && config.data.notLoading)) {
          this.loader = Vue.$loading.show({});
        }
        if (token.Authorization) {
          config.headers = { ...config.headers, ...token };
        }
        return config;
      },
      (error: any) => {
        this.loader && this.loader.hide();
        // Do something with request error
        return Promise.reject(error);
      }
    );
    this.http.interceptors.response.use(
      (response: any) => {
        // Any status code that lie within the range of 2xx cause this function to trigger
        // Do something with response data
        this.loader && this.loader.hide();
        return response;
      },
      (error: any) => {
        this.loader && this.loader.hide();
        // Any status codes that falls outside the range of 2xx cause this function to trigger
        // Do something with response error
        if (
          error.response.status === 401 &&
          router.currentRoute.name !== "login"
        ) {
          // AuthModule.logout();
          router.push({ name: "login" });
          Promise.resolve();
        } else {
          return Promise.reject(error);
        }
      }
    );
  }
}

export default api;
